const globals = {
  textColors: {
    primary: "text-primary-text",
    "primary-high-contrast": "text-primary-text-high-contrast",
    secondary: "text-secondary-text",
    "secondary-high-contrast": "text-secondary-text-high-contrast",
    neutral: "text-neutral-text",
    "neutral-high-contrast": "text-neutral-text-high-contrast",
    info: "text-info-text",
    "info-high-contrast": "text-info-text-high-contrast",
    warning: "text-warning-text",
    "warning-high-contrast": "text-warning-text-high-contrast",
    danger: "text-danger-text",
    "danger-high-contrast": "text-danger-text-high-contrast",
    success: "text-success-text",
    "success-high-contrast": "text-success-text-high-contrast",
    white: "text-white",
    black: "text-black",
    inherit: "text-inherit"
  },
  surfaceColors: {
    primary: "bg-primary-surface",
    secondary: "bg-secondary-surface",
    neutral: "bg-neutral-surface",
    info: "bg-info-surface",
    warning: "bg-warning-surface",
    danger: "bg-danger-surface",
    success: "bg-success-surface"
  },
  elementColors: {
    primary: "bg-primary-element",
    secondary: "bg-secondary-element",
    neutral: "bg-neutral-element",
    info: "bg-info-element",
    warning: "bg-warning-element",
    danger: "bg-danger-element",
    success: "bg-success-element"
  },
  onElementColors: {
    primary: "text-primary-on-element",
    secondary: "text-secondary-on-element",
    neutral: "text-neutral-on-element",
    info: "text-info-on-element",
    warning: "text-warning-on-element",
    danger: "text-danger-on-element",
    success: "text-success-on-element"
  },
  borderColors: {
    primary: "border-primary-border",
    secondary: "border-secondary-border",
    neutral: "border-neutral-border",
    info: "border-info-border",
    warning: "border-warning-border",
    danger: "border-danger-border",
    success: "border-success-border"
  },
  onSurfaceColors: {
    primary: "text-primary-on-surface",
    secondary: "text-secondary-on-surface",
    neutral: "text-neutral-on-surface",
    info: "text-info-on-surface",
    warning: "text-warning-on-surface",
    danger: "text-danger-on-surface",
    success: "text-success-on-surface"
  },
  leadings: {
    none: "leading-none",
    tight: "leading-tight",
    snug: "leading-snug",
    normal: "leading-normal",
    relaxed: "leading-relaxed",
    loose: "leading-loose"
  },
  fontSizes: {
    sm: "text-sm",
    base: "text-base",
    md: "text-md",
    lg: "text-lg",
    xl: "text-xl",
    "2xl": "text-2xl",
    "3xl": "text-3xl",
    "4xl": "text-4xl",
    "5xl": "text-5xl"
  },
  fontWeights: {
    light: "font-light",
    normal: "font-normal",
    semibold: "font-semibold",
    bold: "font-bold"
  },
  floats: {
    left: "float-left",
    right: "float-right"
  },
  lineClamps: {
    none: "line-clamp-none",
    1: "line-clamp-1",
    2: "line-clamp-2",
    3: "line-clamp-3",
    4: "line-clamp-4",
    5: "line-clamp-5",
    6: "line-clamp-6"
  },
  positions: {
    left: "left-0",
    right: "right-0",
    top: "top-0",
    bottom: "bottom-0"
  },
  aspectRatios: {
    auto: "aspect-auto",
    "1/1": "aspect-[1/1]",
    "16/9": "aspect-[16/9]",
    "21/9": "aspect-[21/9]",
    "4/3": "aspect-[4/3]"
  },
  icons: {
    bold: "bx-bold",
    italic: "bx-italic",
    strike: "bx-strikethrough",
    underline: "bx-underline",
    code: "bx-code",
    ul: "bx-list-ul",
    ol: "bx-list-ol",
    quote: "bxs-quote-left",
    hr: "bx-minus",
    undo: "bx-undo",
    redo: "bx-redo",
    zoom: "bx-zoom-in",
    "zoom-out": "bx-zoom-out",
    "rotate-right": "bx-rotate-right",
    "rotate-left": "bx-rotate-left",
    image: "bx-image-alt",
    images: "bx-images",
    home: "bx-home",
    firstPage: "bx-first-page",
    previousPage: "bx-chevron-left",
    nextPage: "bx-chevron-right",
    lastPage: "bx-last-page",
    map: "bx-map",
    navigation: "bxs-navigation",
    mail: "bxs-envelope",
    menu: "bx-menu",
    phone: "bxs-phone",
    mobile: "bx-mobile",
    event: "bx-calendar-event",
    date: "bx-calendar-alt",
    printer: "bxs-printer",
    user: "bx-user",
    search: "bx-search",
    "chevron-left": "bx-chevron-left",
    "chevron-right": "bx-chevron-right",
    "chevron-up": "bx-chevron-up",
    "chevron-down": "bx-chevron-down",
    "caret-right": "bx-caret-right",
    "arrow-right": "bx-right-arrow-alt",
    "arrow-left": "bx-left-arrow-alt",
    "arrow-up": "bx-up-arrow-alt",
    "arrow-down": "bx-down-arrow-alt",
    plus: "bx-plus",
    purchase: "bx-purchase-tag-alt",
    minus: "bx-minus",
    check: "bx-check",
    info: "bx-info-circle",
    group: "bx-group",
    copyright: "bxs-copyright",
    trash: "bx-trash-alt",
    library: "bx-library",
    loader: "bx-loader-alt",
    bell: "bx-bell",
    time: "bx-time",
    x: "bx-x",
    error: "bx-message-error",
    alarm: "bx-alarm-exclamation",
    file: "bxs-file",
    "file-pdf": "bxs-file-pdf",
    "file-image": "bxs-file-image",
    "file-doc": "bxs-file-doc",
    "file-txt": "bxs-file-txt",
    filter: "bx-filter-alt",
    link: "bx-link",
    unlink: "bx-unlink",
    "link-external": "bx-link-external",
    download: "bxs-download",
    volume: "bxs-volume-full",
    news: "bx-news",
    "book-reader": "bx-book-reader",
    pause: "bx-pause",
    play: "bx-play",
    facebook: "bxl-facebook",
    youtube: "bxl-youtube",
    instagram: "bxl-instagram",
    twitter: "bxl-twitter",
    flickr: "bxl-flickr",
    "bx-objects-horizontal-center": "bx-objects-horizontal-center",
    child: "bx-child",
    "universal-access": "bx-universal-access",
    "hard-hat": "bx-hard-hat",
    fork: "bx-fork",
    party: "bx-party",
    buildings: "bx-building",
    chat: "bx-chat",
    "edit-alt": "bx-edit-alt",
    "book-open": "bx-book-open",
    parking: "bx-parking",
    comment: "bx-comment",
    "lock-alt": "bx-lock-alt",
    school: "bx-school",
    exit: "bx-exit",
    heart: "bx-heart",
    cart: "bx-cart",
    "log-in": "bx-log-in",
    water: "bx-water",
    football: "bx-football",
    grid: "bx-grid-alt",
    briefcase: "bx-briefcase",
    "bx-calendar_zeitstrahl_termin": "bx-calendar",
    "bx-calendar-event_zeitstrahl_veranstaltung": "bx-calendar-event",
    "bx-chat_zeitstrahl_buergerbeteiligung": "bx-chat",
    "bx-wrench_zeitstrahl_baubeginn": "bx-wrench",
    "bx-receipt_zeitstrahl_rechtspruefung": "bx-receipt",
    "bx-images_zeitstrahl_bildergalerie": "bx-images",
    "bx-bookmark_zeitstrahl_einweihung": "bx-bookmark",
    "bx-check_zeitstrahl_projektabschluss": "bx-check",
    "bx-hard-hat_zeitstrahl_projektstart": "bx-hard",
    globe: "bx-globe"
  },
  justifyContent: {
    normal: "justify-normal",
    start: "justify-start",
    end: "justify-end",
    center: "justify-center",
    between: "justify-between",
    around: "justify-around",
    evenly: "justify-evenly",
    stretch: "justify-stretch"
  }
};
const settings = {
  NkButton: {
    fixedClasses: "inline-flex items-center transition duration-300 ease-out font-medium relative rounded no-underline",
    disabled: "opacity-50 cursor-not-allowed",
    expand: "block w-full text-center justify-center",
    loading: "relative",
    prependIconAttributes: {
      class: "mr-1"
    },
    appendIconAttributes: {
      class: "ml-1"
    },
    variants: {
      solid: "nk-solid",
      outline: "nk-outline border",
      link: "nk-link border-b-2",
      ghost: "nk-ghost"
    },
    colors: {
      primary: "[&.nk-solid]:bg-primary-element [&.nk-solid]:hover:bg-primary-element--hover [&.nk-solid]:focus:bg-primary-element--active [&.nk-solid]:text-primary-on-element [&.nk-link]:border-primary-element [&.nk-link]:text-primary-text [&.nk-link]:hover:text-primary-text--hover [&.nk-link]:hover:border-primary-element--hover [&.nk-ghost]:text-primary-text [&.nk-ghost]:hover:text-primary-text--hover [&.nk-ghost]:hover:border-primary-element--hover [&.nk-outline]:border-primary-element [&.nk-outline]:text-primary-text [&.nk-outline]:hover:text-primary-text--hover [&.nk-outline]:hover:border-primary-element--hover",
      secondary: "[&.nk-solid]:bg-secondary-element [&.nk-solid]:hover:bg-secondary-element--hover [&.nk-solid]:focus:bg-secondary-element--active [&.nk-solid]:text-secondary-on-element [&.nk-link]:border-secondary-element [&.nk-link]:text-secondary-text [&.nk-link]:hover:text-secondary-text--hover [&.nk-link]:hover:border-secondary-element--hover [&.nk-ghost]:text-secondary-text [&.nk-ghost]:hover:text-secondary-text--hover [&.nk-ghost]:hover:border-secondary-element--hover [&.nk-outline]:border-secondary-element [&.nk-outline]:text-secondary-text [&.nk-outline]:hover:text-secondary-text--hover [&.nk-outline]:hover:border-secondary-element--hover",
      neutral: "[&.nk-solid]:bg-neutral-element [&.nk-solid]:hover:bg-neutral-element--hover [&.nk-solid]:focus:bg-neutral-element--active [&.nk-solid]:text-neutral-on-element [&.nk-link]:border-neutral-element [&.nk-link]:text-neutral-text [&.nk-link]:hover:text-neutral-text--hover [&.nk-link]:hover:border-neutral-element--hover [&.nk-ghost]:text-neutral-text [&.nk-ghost]:hover:text-secondary-text--hover [&.nk-ghost]:hover:border-neutral-element--hover [&.nk-outline]:border-neutral-element [&.nk-outline]:text-neutral-text [&.nk-outline]:hover:text-neutral-text--hover [&.nk-outline]:hover:border-neutral-element--hover",
      danger: "[&.nk-solid]:bg-danger-element [&.nk-solid]:hover:bg-danger-element--hover [&.nk-solid]:focus:bg-danger-element--active [&.nk-solid]:text-danger-on-element [&.nk-link]:border-danger-element [&.nk-link]:text-danger-text [&.nk-link]:hover:text-danger-text--hover [&.nk-link]:hover:border-danger-element--hover [&.nk-ghost]:text-danger-text [&.nk-ghost]:hover:text-danger-text--hover [&.nk-ghost]:hover:border-danger-element--hover [&.nk-outline]:border-danger-element [&.nk-outline]:text-danger-text [&.nk-outline]:hover:text-danger-text--hover [&.nk-outline]:hover:border-danger-element--hover",
      success: "[&.nk-solid]:bg-success-element [&.nk-solid]:hover:bg-success-element--hover [&.nk-solid]:focus:bg-success-element--active [&.nk-solid]:text-success-on-element [&.nk-link]:border-success-element [&.nk-link]:text-success-text [&.nk-link]:hover:text-success-text--hover [&.nk-link]:hover:border-success-element--hover [&.nk-ghost]:text-success-text [&.nk-ghost]:hover:text-success-text--hover [&.nk-ghost]:hover:border-success-element--hover [&.nk-outline]:border-success-element [&.nk-outline]:text-success-text [&.nk-outline]:hover:text-success-text--hover [&.nk-outline]:hover:border-success-element--hover",
      info: "[&.nk-solid]:bg-info-element [&.nk-solid]:hover:bg-info-element--hover [&.nk-solid]:focus:bg-info-element--active [&.nk-solid]:text-info-on-element [&.nk-link]:border-info-element [&.nk-link]:text-info-text [&.nk-link]:hover:text-info-text--hover [&.nk-link]:hover:border-info-element--hover [&.nk-ghost]:text-info-text [&.nk-ghost]:hover:text-info-text--hover [&.nk-ghost]:hover:border-info-element--hover [&.nk-outline]:border-info-element [&.nk-outline]:text-info-text [&.nk-outline]:hover:text-info-text--hover [&.nk-outline]:hover:border-info-element--hover",
      warning: "[&.nk-solid]:bg-warning-element [&.nk-solid]:hover:bg-warning-element--hover [&.nk-solid]:focus:bg-warning-element--active [&.nk-solid]:text-warning-on-element [&.nk-link]:border-warning-element [&.nk-link]:text-warning-text [&.nk-link]:hover:text-warning-text--hover [&.nk-link]:hover:border-warning-element--hover [&.nk-ghost]:text-warning-text [&.nk-ghost]:hover:text-warning-text--hover [&.nk-ghost]:hover:border-warning-element--hover [&.nk-outline]:border-warning-element [&.nk-outline]:text-warning-text [&.nk-outline]:hover:text-warning-text--hover [&.nk-outline]:hover:border-warning-element--hover",
      white: "[&.nk-solid]:bg-white-element [&.nk-solid]:hover:bg-white-element--hover [&.nk-solid]:focus:bg-white-element--active [&.nk-solid]:text-white-on-element [&.nk-link]:border-white-element [&.nk-link]:text-white-text [&.nk-link]:hover:text-white-text--hover [&.nk-link]:hover:border-white-element--hover [&.nk-ghost]:text-white-text [&.nk-ghost]:hover:text-white-text--hover [&.nk-ghost]:hover:border-white-element--hover [&.nk-outline]:border-white-element [&.nk-outline]:text-white-text [&.nk-outline]:hover:text-white-text--hover [&.nk-outline]:hover:border-white-element--hover"
    },
    sizes: {
      default: "px-3 py-2 min-h-6 text-base",
      sm: "px-3 py-2 text-sm",
      md: "p-3 text-md",
      lg: "p-3 text-lg",
      collapse: "p-0"
    }
  },
  NkIcon: {
    fixedClasses: "nk-icon bx align-middle",
    icons: globals.icons,
    sizes: {
      base: "text-base",
      xs: "text-xs",
      sm: "text-sm",
      md: "text-md",
      lg: "text-lg",
      xl: "text-xl",
      "2xl": "text-2xl",
      "3xl": "text-3xl",
      "4xl": "text-4xl"
    },
    surfaceColors: globals.elementColors,
    iconColors: globals.onElementColors,
    variants: {
      default: "inline-block",
      boxed: "p-[0.25em] text-center rounded-full"
    }
  },
  NkTitle: {
    fixedClasses: "nk-title",
    sizes: globals.fontSizes,
    colors: globals.textColors,
    leadings: globals.leadings,
    weights: globals.fontWeights,
    lineClamps: globals.lineClamps
  },
  NkText: {
    fixedClasses: "nk-text",
    lineClamps: globals.lineClamps,
    sizes: globals.fontSizes,
    colors: globals.textColors,
    weights: globals.fontWeights
  },
  NkBadge: {
    fixedClasses: "cursor-default inline-block px-[0.5em] py-[0.25em]",
    surfaceColors: globals.surfaceColors,
    onSurfaceColors: globals.onSurfaceColors,
    sizes: {
      sm: "text-sm",
      base: "text-base",
      md: "text-md",
      lg: "text-lg"
    }
  },
  NkDate: {
    variants: {
      default: {
        wrapper: "inline-flex flex-col bg-neutral-surface text-neutral-on-surface text-center p-3",
        day: "text-base font-bold",
        month: "text-sm uppercase tracking-wide"
      }
    }
  },
  NkAddress: {
    fixedClasses: {
      wrapper: "leading-relaxed",
      text: null
    },
    variants: {
      default: {
        wrapper: "flex flex-col sm:flex-row -mx-3 -my-2",
        text: "px-3 py-2 m-0"
      },
      vertical: {
        wrapper: "flex flex-col",
        text: "m-0"
      }
    }
  },
  NkLink: {
    classes: "underline text-primary-element hover:text-primary-element--hover focus:text-primary-element--active"
  },
  NkContainer: {
    variants: {
      default: "container px-4",
      fluid: "max-w-full"
    }
  },
  NkCol: {
    cols: {
      full: "w-full",
      auto: "flex-1",
      shrink: "w-auto",
      "1/12": "w-1/12",
      "2/12": "w-2/12",
      "3/12": "w-3/12",
      "4/12": "w-4/12",
      "5/12": "w-5/12",
      "6/12": "w-6/12",
      "7/12": "w-7/12",
      "8/12": "w-8/12",
      "9/12": "w-9/12",
      "10/12": "w-10/12",
      "11/12": "w-11/12",
      "12/12": "w-12/12"
    },
    xs: {
      full: "xs:w-full",
      auto: "xs:flex-1",
      shrink: "xs:w-auto",
      "1/12": "xs:w-1/12",
      "2/12": "xs:w-2/12",
      "3/12": "xs:w-3/12",
      "4/12": "xs:w-4/12",
      "5/12": "xs:w-5/12",
      "6/12": "xs:w-6/12",
      "7/12": "xs:w-7/12",
      "8/12": "xs:w-8/12",
      "9/12": "xs:w-9/12",
      "10/12": "xs:w-10/12",
      "11/12": "xs:w-11/12",
      "12/12": "xs:w-12/12"
    },
    sm: {
      full: "sm:w-full",
      auto: "sm:flex-1",
      shrink: "sm:w-auto",
      "1/12": "sm:w-1/12",
      "2/12": "sm:w-2/12",
      "3/12": "sm:w-3/12",
      "4/12": "sm:w-4/12",
      "5/12": "sm:w-5/12",
      "6/12": "sm:w-6/12",
      "7/12": "sm:w-7/12",
      "8/12": "sm:w-8/12",
      "9/12": "sm:w-9/12",
      "10/12": "sm:w-10/12",
      "11/12": "sm:w-11/12",
      "12/12": "sm:w-12/12"
    },
    md: {
      full: "md:w-full",
      auto: "md:flex-1",
      shrink: "md:w-auto",
      "1/12": "md:w-1/12",
      "2/12": "md:w-2/12",
      "3/12": "md:w-3/12",
      "4/12": "md:w-4/12",
      "5/12": "md:w-5/12",
      "6/12": "md:w-6/12",
      "7/12": "md:w-7/12",
      "8/12": "md:w-8/12",
      "9/12": "md:w-9/12",
      "10/12": "md:w-10/12",
      "11/12": "md:w-11/12",
      "12/12": "md:w-12/12"
    },
    lg: {
      full: "lg:w-full",
      auto: "lg:flex-1",
      shrink: "lg:w-auto",
      "1/12": "lg:w-1/12",
      "2/12": "lg:w-2/12",
      "3/12": "lg:w-3/12",
      "4/12": "lg:w-4/12",
      "5/12": "lg:w-5/12",
      "6/12": "lg:w-6/12",
      "7/12": "lg:w-7/12",
      "8/12": "lg:w-8/12",
      "9/12": "lg:w-9/12",
      "10/12": "lg:w-10/12",
      "11/12": "lg:w-11/12",
      "12/12": "lg:w-12/12"
    },
    xl: {
      full: "xl:w-full",
      auto: "xl:flex-1",
      shrink: "xl:w-auto",
      "1/12": "xl:w-1/12",
      "2/12": "xl:w-2/12",
      "3/12": "xl:w-3/12",
      "4/12": "xl:w-4/12",
      "5/12": "xl:w-5/12",
      "6/12": "xl:w-6/12",
      "7/12": "xl:w-7/12",
      "8/12": "xl:w-8/12",
      "9/12": "xl:w-9/12",
      "10/12": "xl:w-10/12",
      "11/12": "xl:w-11/12",
      "12/12": "xl:w-12/12"
    },
    "2xl": {
      full: "2xl:w-full",
      auto: "2xl:flex-1",
      shrink: "2xl:w-auto",
      "1/12": "2xl:w-1/12",
      "2/12": "2xl:w-2/12",
      "3/12": "2xl:w-3/12",
      "4/12": "2xl:w-4/12",
      "5/12": "2xl:w-5/12",
      "6/12": "2xl:w-6/12",
      "7/12": "2xl:w-7/12",
      "8/12": "2xl:w-8/12",
      "9/12": "2xl:w-9/12",
      "10/12": "2xl:w-10/12",
      "11/12": "2xl:w-11/12",
      "12/12": "2xl:w-12/12"
    },
    offset: "ml-auto",
    order: {
      1: "order-1",
      2: "order-2",
      3: "order-3",
      4: "order-4",
      5: "order-5",
      6: "order-6",
      7: "order-7",
      8: "order-8",
      9: "order-9",
      10: "order-10",
      11: "order-11",
      12: "order-12"
    },
    orderSm: {
      1: "sm:order-1",
      2: "sm:order-2",
      3: "sm:order-3",
      4: "sm:order-4",
      5: "sm:order-5",
      6: "sm:order-6",
      7: "sm:order-7",
      8: "sm:order-8",
      9: "sm:order-9",
      10: "sm:order-10",
      11: "sm:order-11",
      12: "sm:order-12"
    },
    orderMd: {
      1: "md:order-1",
      2: "md:order-2",
      3: "md:order-3",
      4: "md:order-4",
      5: "md:order-5",
      6: "md:order-6",
      7: "md:order-7",
      8: "md:order-8",
      9: "md:order-9",
      10: "md:order-10",
      11: "md:order-11",
      12: "md:order-12"
    },
    orderLg: {
      1: "lg:order-1",
      2: "lg:order-2",
      3: "lg:order-3",
      4: "lg:order-4",
      5: "lg:order-5",
      6: "lg:order-6",
      7: "lg:order-7",
      8: "lg:order-8",
      9: "lg:order-9",
      10: "lg:order-10",
      11: "lg:order-11",
      12: "lg:order-12"
    },
    orderXl: {
      1: "xl:order-1",
      2: "xl:order-2",
      3: "xl:order-3",
      4: "xl:order-4",
      5: "xl:order-5",
      6: "xl:order-6",
      7: "xl:order-7",
      8: "xl:order-8",
      9: "xl:order-9",
      10: "xl:order-10",
      11: "xl:order-11",
      12: "xl:order-12"
    },
    order2Xl: {
      1: "2xl:order-1",
      2: "2xl:order-2",
      3: "2xl:order-3",
      4: "2xl:order-4",
      5: "2xl:order-5",
      6: "2xl:order-6",
      7: "2xl:order-7",
      8: "2xl:order-8",
      9: "2xl:order-9",
      10: "2xl:order-10",
      11: "2xl:order-11",
      12: "2xl:order-12"
    },
    gutter: {
      1: "px-1",
      2: "px-2",
      3: "px-3",
      4: "px-4",
      5: "px-5",
      6: "px-6",
      7: "px-7",
      8: "px-8",
      9: "px-9",
      10: "px-10",
      11: "px-11",
      12: "px-12"
    },
    verticalGutter: {
      1: "py-1",
      2: "py-2",
      3: "py-3",
      4: "py-4",
      5: "py-5",
      6: "py-6",
      7: "py-7",
      8: "py-8",
      9: "py-9",
      10: "py-10",
      11: "py-11",
      12: "py-12"
    }
  },
  NkRow: {
    classes: "flex flex-wrap",
    gutter: {
      1: "-mx-1",
      2: "-mx-2",
      3: "-mx-3",
      4: "-mx-4",
      5: "-mx-5",
      6: "-mx-6",
      7: "-mx-7",
      8: "-mx-8",
      9: "-mx-9",
      10: "-mx-10",
      11: "-mx-11",
      12: "-mx-12"
    },
    verticalGutter: {
      1: "-my-1",
      2: "-my-2",
      3: "-my-3",
      4: "-my-4",
      5: "-my-5",
      6: "-my-6",
      7: "-my-7",
      8: "-my-8",
      9: "-my-9",
      10: "-my-10",
      11: "-my-11",
      12: "-my-12"
    },
    alignItems: {
      start: "items-start",
      center: "items-center",
      end: "items-end",
      baseline: "items-baseline",
      stretch: "items-stretch"
    },
    justifyContent: globals.justifyContent
  },
  NkMeta: {
    variants: {
      default: "flex items-center uppercase tracking-wide",
      normal: "flex items-center"
    },
    sizes: globals.fontSizes,
    colors: globals.textColors
  },
  NkLoader: {
    classes: "flex items-center justify-center",
    colors: globals.textColors
  },
  NkWrapper: {
    spacings: {
      margin: {
        xs: "my-1",
        sm: "my-2",
        default: "my-4",
        md: "my-6",
        lg: "my-10",
        xl: "my-12",
        "2xl": "my-16"
      },
      padding: {
        xs: "py-1",
        sm: "py-2",
        default: "py-3",
        md: "py-4",
        lg: "py-6",
        xl: "py-8",
        "2xl": "py-10"
      }
    }
  },
  NkWidgetPushNotification: {
    variants: {
      inline: {
        wrapper: "",
        button: "pointer-events-auto bg-primary-element hover:bg-primary-element--hover focus:bg-primary-element--active text-primary-on-element rounded-full p-3 leading-none",
        dialogOuter: "fixed bottom-0 flex justify-center items-end left-0 p-3 z-50 w-full h-full bg-black/90",
        dialogInner: "bg-white shadow-xl p-3 sm:w-screen max-w-sm rounded"
      },
      floating: {
        wrapper: "fixed bottom-0 left-0 p-3 z-50 w-full sm:w-auto pointer-events-none",
        button: "pointer-events-auto bg-primary-element hover:bg-primary-element--hover focus:bg-primary-element--active text-primary-on-element rounded-full p-3 leading-none shadow-lg",
        dialogOuter: "pointer-events-auto absolute bottom-full left-0 sm:left-full px-3 sm:p-0 w-full sm:-m-2 sm:w-screen max-w-sm",
        dialogInner: "bg-white shadow-xl p-3"
      }
    }
  },
  NkDivider: {
    classes: "border-bottom",
    colors: globals.borderColors,
    spacings: {
      xs: "my-1",
      sm: "my-2",
      md: "my-4",
      lg: "my-6",
      xl: "my-8",
      "2xl": "my-10"
    }
  },
  NkList: {
    fixedClasses: {
      wrapper: "list-outside [&.list-disc]:pl-4 [&.list-decimal]:pl-4"
    },
    variants: {
      unordered: { wrapper: "list-disc" },
      ordered: { wrapper: "list-decimal" },
      clean: { wrapper: "list-none" },
      table: {
        wrapper: "list-none pl-3",
        item: "border-b border-neutral-border py-2"
      },
      horizontal: {
        wrapper: "md:flex flex-wrap list-none -mx-2 -mt-1 mb-1",
        item: "inline-flex items-center px-2 py-1"
      },
      overview: {
        wrapper: "list-none block -my-4",
        item: "py-8 border-b border-neutral-border last:border-b-0"
      }
    }
  },
  NkAccordion: {
    iconClosed: "minus",
    iconOpen: "plus",
    iconTransitionName: "fade",
    iconSize: "md",
    titleSizes: globals.fontSizes,
    variants: {
      default: {
        wrapper: "",
        header: "group block border-b text-neutral-text-high-contrast border-neutral-border py-2 hover:text-neutral-text-high-contrast--hover focus:text-neutral-text-high-contrast--active",
        content: "py-4"
      },
      solid: {
        wrapper: "",
        header: "group block border-b border-primary-border py-3 px-4 bg-primary-element hover:bg-primary-element--hover focus:bg-primary-element--hover text-primary-on-element--high-contrast hover:text-primary-on-element focus:text-primary-on-element transition duration-300",
        content: "py-4 px-1"
      }
    }
  },
  NkAlert: {
    fixedClasses: {
      container: "relative border-l-4 text-type rounded-sm p-3 pr-5 mb-3",
      wrapper: "flex items-center",
      closeButton: "transition duration-300 ease-out absolute top-0 right-0 p-2 opacity-50 hover:opacity-100"
    },
    hasIcon: true,
    variants: {
      neutral: {
        container: "bg-neutral-surface  border-neutral-border text-neutral-on-surface"
      },
      success: {
        container: "bg-success-surface border-success-border text-success-on-surface",
        icon: "check",
        iconBackground: true,
        iconColor: "success",
        iconVariant: "boxed"
      },
      danger: {
        container: "bg-danger-surface border-danger-border text-danger-on-surface",
        icon: "error",
        iconBackground: true,
        iconColor: "danger",
        iconVariant: "boxed"
      },
      info: {
        container: "bg-info-surface border-info-border text-info-on-surface",
        icon: "info",
        iconBackground: true,
        iconColor: "info",
        iconVariant: "boxed"
      },
      warning: {
        container: "bg-warning-surface border-warning-border text-warning-on-surface",
        icon: "alarm",
        iconBackground: true,
        iconColor: "warning",
        iconVariant: "boxed"
      }
    }
  },
  NkBox: {
    variants: {
      default: "bg-neutral-surface px-4 py-3 mb-3",
      transparent: "px-4 py-3",
      sidebar: "p-4 bg-neutral-surface border-t-4 border-neutral-border"
    }
  },
  NkBreadcrumb: {
    classes: {
      wrapper: "container mx-auto my-4 px-3",
      container: "",
      list: "list-none divide-x divide-neutral-border truncate -mx-2",
      item: "italic text-sm py-1 px-2 inline-flex align-middle",
      link: "text-primary-text inline-flex items-center align-middle link-active-exact:text-neutral-text",
      currentPage: "inline-flex items-center align-middle"
    },
    homeIcon: {
      icon: "home",
      variant: "boxed",
      backgroundColor: true,
      color: "primary",
      class: "mr-2"
    }
  },
  NkCard: {
    variants: {
      default: {
        wrapper: "flex flex-col min-h-full h-full gap-3",
        body: "py-3 flex flex-col h-full gap-3",
        header: "",
        image: "",
        footer: "mt-auto",
        link: "[&_.nk-title]:text-primary-text [&_.nk-title]:underline transition-all duration-300 ease-out"
      },
      row: {
        wrapper: "flex flex-wrap min-h-full",
        body: "w-full md:flex-1 p-6 bg-neutral-surface flex flex-col gap-3",
        header: "w-full md:flex-1",
        image: "w-full md:flex-1",
        footer: "pt-5 mt-auto",
        link: ""
      },
      boxed: {
        wrapper: "flex flex-col min-h-full h-full justify-between bg-neutral-surface flex flex-col",
        body: "flex flex-col gap-3 p-6 h-full",
        header: "px-6 pt-6",
        image: "",
        footer: "mt-auto p-4 pt-0",
        link: "transition duration-300 ease-out transform hover:-translate-y-1 hover:text-neutral-on-surface hover:bg-neutral-surface--active focus:text-neutral-on-surface focus:shadow-md focus:bg-neutral-surface--active"
      },
      imagePreview: {
        wrapper: "flex flex-col min-h-full h-full justify-between bg-neutral-surface flex flex-col",
        body: "flex flex-col gap-3 p-6 h-full",
        header: "",
        image: "",
        footer: "mt-auto p-4 pt-0",
        link: "transition duration-300 ease-out transform hover:-translate-y-1 hover:text-neutral-on-surface hover:bg-neutral-surface--active focus:text-neutral-on-surface focus:shadow-md focus:bg-neutral-surface--active"
      },
      imageOverlay: {
        wrapper: "block relative overflow-hidden",
        body: "absolute bottom-0 left-0 w-full px-5 pb-6 pt-10 text-white bg-gradient-to-t from-black/75 to-black/0 text-shadow-sm flex flex-col gap-3",
        header: "",
        image: "",
        footer: "",
        link: "transition transform duration-300 ease-out hover:-translate-y-1 hover:shadow-md focus:-translate-y-1 focus:shadow-md"
      }
    }
  },
  NkImage: {
    classes: {
      wrapper: "relative",
      copyright: "inline-block absolute z-30 opacity-75 leading-none rounded-full p-1 text-white text-sm",
      container: "block relative bg-neutral-surface w-full",
      image: "max-w-full w-full lazyload transition-opacity duration-500 ease-out delay-100",
      noteLabel: "absolute bottom-0 right-0 inline-flex items-center bg-black bg-opacity-75 m-2 px-2 py-1 text-white text-sm rounded whitespace-no-wrap",
      noteLabelIcon: "mr-1 text-base",
      figcaption: "h-auto relative italic my-2 text-base"
    },
    aspectRatios: globals.aspectRatios,
    positions: globals.positions,
    floats: globals.floats,
    imageSrcset: [480, 640, 768, 1024, 1280, 1920]
  },
  NkDrilldown: {
    fixedClasses: "",
    variants: {
      default: {
        menu: "nk-drilldown bg-neutral-surface rounded overflow-hidden",
        menuInner: "list-none",
        menuItem: "border-b border-neutral-border last:border-0",
        menuItemButton: "relative flex w-full py-4 px-4 text-primary-text hover:bg-neutral-surface-hover",
        menuItemButtonActive: "border-b border-neutral-border text-primary-text",
        menuItemIcon: "no-underline before:no-underline after",
        menuItemButtonIcon: "ml-auto no-underline absolute right-0 mr-3 transform transition-transform duration-300 ease-in-out ",
        menuItemButtonIconActive: "rotate-180",
        menuItemLink: "block py-4 px-4 link-active:bg-primary-element link-active:text-primary-on-element link-active-exact:bg-primary-element link-active-exact:text-primary-on-element group-[.is-submenu]:pl-8",
        menuItemLinkIcon: "ml-auto no-underline before:no-underline",
        submenu: "bg-neutral-surface--active group is-submenu"
      }
    }
  },
  NkTabs: {
    fixedClasses: "",
    variants: {
      default: {
        wrapper: "",
        header: "flex flex-wrap list-none p-1",
        headerItem: "w-auto p-1",
        headerButton: "block py-2 px-3 font-bold text-neutral-text",
        headerButtonActive: "bg-primary-element text-primary-on-element focus:bg-primary-element--active hover:bg-primary-element--hover",
        content: "my-3 p-3"
      }
    }
  },
  NkPagination: {
    classes: {
      wrapper: "my-3",
      list: "flex items-center list-none -mx-1",
      item: "text-sm px-1",
      link: "inline-block text-type text-center hover:text-primary-text--hover focus:text-primary-text--active p-2",
      linkActive: "inline-block text-center text-primary-500 font-bold p-2",
      button: "inline-flex border-solid border border-element-border p-2 items-center justify-center bg-primary-element text-primary-on-element hover:bg-primary-element--hover hover:text-primary-on-element focus:bg-primary-element--active focus:text-primary-on-element",
      buttonDisabled: "inline-flex border-solid border border-neutral-border p-2 items-center justify-center cursor-not-allowed",
      currentItem: ""
    },
    justifyContent: globals.justifyContent,
    firstPageIcon: "firstPage",
    previousPageIcon: "previousPage",
    nextPageIcon: "nextPage",
    lastPageIcon: "lastPage"
  },
  NkDrawer: {
    classes: {
      backdrop: "z-50 fixed inset-0 bg-black bg-opacity-75",
      wrapper: "flex flex-col w-full md:max-w-md bg-white h-full",
      header: "flex justify-between items-center px-4 py-3 border-b border-neutral-border text-lg font-bold",
      closeButton: "text-xl opacity-50 hover:opacity-100 focus:opacity-100",
      footer: "px-4 py-3 border-t border-neutral-border mt-auto",
      body: "px-4 py-4 overflow-auto scrolling-touch min-h-0"
    }
  },
  NkModal: {
    variants: {
      default: {
        backdrop: "z-50 flex fixed inset-0 bg-black bg-opacity-75 px-2 py-2 lg:py-6",
        wrapper: "w-full m-auto relative bg-white",
        header: "flex justify-between items-center px-4 py-3 border-b border-neutral-border text-base font-bold",
        closeButton: "text-md opacity-50 hover:opacity-100 focus:opacity-100",
        footer: "px-4 py-3 border-t border-neutral-border mt-auto",
        body: "px-4 py-4 overflow-auto scrolling-touch min-h-0"
      },
      // Specific variant for the Nina Notification Modal
      nina: {
        backdrop: "z-50 flex fixed inset-0 bg-black bg-opacity-75 px-2 py-2 lg:py-6",
        wrapper: "w-full m-auto relative bg-[#003253] border-t-8 border-[#EC7000]",
        header: "absolute z-10 right-0 flex justify-between items-center px-4 py-3 text-base font-bold",
        closeButton: "text-md text-white text-opacity-50 hover:opacity-100 focus:opacity-100 ml-auto bg-[#EC7000] rounded-full p-2 hover:text-opacity-100",
        footer: "px-4 py-3 border-t border-neutral-border mt-auto",
        body: "px-4 py-8 overflow-auto scrolling-touch min-h-0"
      }
    },
    sizes: {
      sm: "max-w-sm",
      md: "max-w-md",
      lg: "max-w-lg",
      xl: "max-w-xl",
      "2xl": "max-w-2xl",
      "3xl": "max-w-3xl"
    }
  },
  NkSidebar: {
    classes: {
      wrapper: "space-y-12"
    }
  },
  NkNav: {
    fixedClasses: "",
    variants: {
      default: {
        wrapper: "",
        item: "border-b border-neutral-border text-md",
        title: "font-bold",
        text: "",
        content: "inline-block text-base underline",
        link: "block py-3 px-2 transition duration-300 group text-primary-text hover:text-primary-text--hover link-active:bg-primary-surface link-active:text-primary-on-surface",
        prependIcon: {
          icon: "chevron-right",
          class: "mr-1"
        }
      },
      footprint: {
        wrapper: "flex flex-wrap divide-x divide-neutral-border -mx-2",
        item: "",
        title: "",
        text: "",
        link: "flex items-center py-1 px-2 text-primary-text hover:text-primary-text--hover transition duration-300 group",
        prependIcon: false
      },
      resources: {
        wrapper: "border border-neutral-border rounded-sm",
        item: "border-b border-neutral-border",
        link: "flex items-center flex-no-wrap p-3 text-primary-text hover:text-primary-text--hover  transition duration-300 group no-underline",
        content: "px-3 flex-1 overflow-hidden underline",
        title: "font-bold group-hover:text-primary-text--hover group-focus:text-primary-text--active transition duration-300 underline",
        text: " truncate inline-block text-neutral-text",
        longtext: "whitespace-normal",
        prependIcon: {
          icon: "file",
          color: "primary-500",
          size: "xl",
          inline: false
        },
        appendIcon: {
          icon: "download",
          color: "type",
          size: "xl",
          inline: false
        }
      },
      links: {
        wrapper: "border border-neutral-border rounded-sm",
        item: "border-b border-neutral-border",
        link: "flex items-center flex-no-wrap py-3 px-2 text-primary-text hover:text-primary-text--hover transition duration-300 group no-underline",
        content: "truncate px-3 underline",
        text: "italic truncate",
        appendIcon: {
          icon: "chevron-right",
          color: "primary-500",
          size: "xl",
          inline: false
        }
      },
      abc: {
        wrapper: "flex flex-wrap justify-start",
        item: "",
        title: "",
        text: "",
        link: "block px-2 py-2 m-1 text-primary-text hover:text-primary-on-element focus:text-white text-center hover:bg-primary-element focus:bg-primary-element--active link-active:bg-primary-element link-active:text-primary-on-element"
      }
    }
  },
  NkFilterbar: {
    variants: {
      default: {
        wrapper: "md:bg-neutral-surface md:p-3 mb-3"
      }
    }
  },
  NkCarousel: {
    fixedClasses: {
      wrapper: "nk-carousel-wrapper"
    },
    variants: {
      default: {
        sliderOptions: {
          spaceBetween: 16,
          slidesPerView: 1.25,
          centeredSlides: true,
          autoplay: {
            delay: 2500
          },
          breakpoints: {
            640: {
              slidesPerView: 2,
              spaceBetween: 16,
              centeredSlides: false
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 24,
              centeredSlides: false
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 24,
              centeredSlides: false
            },
            1280: {
              slidesPerView: 3,
              spaceBetween: 24,
              centeredSlides: false
            },
            1600: {
              slidesPerView: 4,
              spaceBetween: 24,
              centeredSlides: false
            }
          }
        },
        wrapper: "relative",
        slider: "sm:overflow-hidden",
        sliderItem: "flex items-center justify-center",
        slideContent: "h-full w-full",
        slideBackgroundImage: "",
        controls: "flex justify-between items-center",
        buttonWrapper: "",
        button: "transition ease-out duration-300 justify-center items-center text-center text-secondary-element text-xl hover:text-secondary-element--hover focus:text-secondary-element--active hidden sm:inline-flex",
        buttonLeft: "left-0",
        buttonLeftIcon: "chevron-left",
        buttonRight: "right-0",
        buttonRightIcon: "chevron-right",
        buttonDisabled: "opacity-50 cursor-not-allowed",
        paginationWrapper: "block mt-5 mx-auto sm:mx-0",
        pagination: "flex justify-center md:justify-start list-none -mx-1",
        paginationButton: "block w-8 is-active:w-10 h-3 mx-1 rounded bg-secondary-surface hover:bg-secondary-surface--active is-active:bg-secondary-element--active transition",
        paginationButtonActive: "is-active"
      },
      gallery: {
        sliderOptions: {
          spaceBetween: 16,
          slidesPerView: 1.5,
          centeredSlides: true,
          pagination: false
        },
        wrapper: "relative",
        slider: "sm:overflow-hidden",
        sliderItem: "",
        slideContent: "bg-neutral-surface h-full flex justify-center items-center relative z-0 overflow-hidden",
        slideBackgroundImage: "",
        buttonWrapper: "absolute top-1/2 left-0 w-full flex z-10 justify-between transform -translate-y-1/2 pointer-events-none px-6",
        button: "pointer-events-auto rounded transition ease-out duration-300 justify-center items-center text-center text-secondary-on-element text-xl inline-flex bg-secondary-element hover:bg-secondary-element--hover focus:bg-secondary-element--active",
        buttonLeft: "",
        buttonLeftIcon: "chevron-left",
        buttonRight: "",
        buttonRightIcon: "chevron-right",
        buttonDisabled: "opacity-50 cursor-not-allowed",
        paginationWrapper: "block mt-5",
        pagination: "flex justify-center md:justify-start list-none -mx-1",
        paginationButton: "block w-8 is-active:w-10 h-3 mx-1 rounded bg-secondary-surface hover:bg-secondary-surface--active is-active:bg-secondary-element--active transition",
        paginationButtonActive: "is-active"
      },
      hero: {
        sliderOptions: {
          spaceBetween: 0,
          slidesPerView: 1,
          speed: 600,
          centeredSlides: true,
          navigation: true,
          effect: "fade",
          autoplay: {
            delay: 6e3
          },
          fadeEffect: {
            crossFade: true
          }
        },
        wrapper: "relative w-full bg-secondary-surface overflow-hidden",
        slider: "h-full min-h-full",
        sliderItem: "flex items-center h-full aspect-[1/1] lg:aspect-[16/9] lg:aspect-[21/9] max-h-screen",
        slideContent: "relative z-10 py-10 px-3 max-w-screen-sm mx-auto text-center text-shadow-sm flex h-full items-center justify-center",
        slideBackgroundImage: "absolute top-0 left-0 object-cover lazyload h-full w-full",
        controls: "",
        buttonWrapper: "absolute bottom-0 right-0 hidden sm:flex my-6 px-3 translate-y-1/2 transform z-20",
        button: "transition ease-out duration-300 justify-center items-center text-center text-white/50 text-xl hover:text-white/75 focus:text-white hidden sm:inline-flex",
        buttonLeft: "",
        buttonLeftIcon: "chevron-left",
        buttonRight: "",
        buttonRightIcon: "chevron-right",
        buttonDisabled: "opacity-50 cursor-not-allowed pointer-events-none",
        paginationWrapper: "absolute w-full bottom-0 block z-10 my-6 translate-y-1/2 transform",
        pagination: "flex flex-wrap items-center list-none -mx-1 justify-center",
        paginationButton: "block w-8 is-active:w-10 h-3 mx-1 rounded bg-white/50 hover:bg-white/75 is-active:bg-white transition-all",
        paginationButtonActive: "is-active"
      },
      "hero-slim": {
        sliderOptions: {
          spaceBetween: 0,
          slidesPerView: 1,
          speed: 600,
          centeredSlides: true,
          navigation: true,
          effect: "fade",
          autoplay: {
            delay: 6e3
          },
          fadeEffect: {
            crossFade: true
          }
        },
        wrapper: "relative w-full bg-secondary-surface overflow-hidden",
        slider: "h-full min-h-full",
        sliderItem: "flex items-center h-full aspect-[16/9] lg:aspect-[21/9] max-h-[560px]",
        slideContent: "relative z-10 py-10 px-3 max-w-screen-sm mx-auto text-center text-shadow-sm flex h-full items-center justify-center",
        slideBackgroundImage: "absolute top-0 left-0 object-cover lazyload h-full w-full",
        controls: "",
        buttonWrapper: "absolute bottom-0 right-0 hidden sm:flex my-6 px-3 translate-y-1/2 transform z-20",
        button: "transition ease-out duration-300 justify-center items-center text-center text-white/50 text-xl hover:text-white/75 focus:text-white hidden sm:inline-flex",
        buttonLeft: "",
        buttonLeftIcon: "chevron-left",
        buttonRight: "",
        buttonRightIcon: "chevron-right",
        buttonDisabled: "opacity-50 cursor-not-allowed pointer-events-none",
        paginationWrapper: "absolute w-full bottom-0 block z-10 my-6 translate-y-1/2 transform",
        pagination: "flex flex-wrap items-center list-none -mx-1 justify-center",
        paginationButton: "block w-8 is-active:w-10 h-3 mx-1 rounded bg-white/50 hover:bg-white/75 is-active:bg-white transition-all",
        paginationButtonActive: "is-active"
      },
      overlay: {
        sliderOptions: {
          pagination: false,
          spaceBetween: 0,
          slidesPerView: 1,
          speed: 600,
          centeredSlides: true,
          navigation: false,
          effect: "fade",
          autoplay: {
            delay: 6e3
          },
          fadeEffect: {
            crossFade: true
          }
        },
        wrapper: "absolute top-0 left-0 w-full h-full",
        slider: "h-full min-h-full",
        sliderItem: "w-full h-full",
        buttonLeft: "",
        buttonLeftIcon: "chevron-left",
        buttonRight: "",
        buttonRightIcon: "chevron-right"
      },
      "portal-events": {
        sliderOptions: {
          centeredSlides: false,
          pagination: false,
          slidesPerView: 1,
          spaceBetween: 16,
          breakpoints: {
            480: {
              slidesPerView: 1.75,
              spaceBetween: 16
            },
            576: {
              slidesPerView: 2,
              spaceBetween: 24
            },
            1024: {
              slidesPerView: 3
            }
          }
        },
        wrapper: "relative overflow-visible",
        pagination: "flex justify-center md:justify-end list-none -mx-1",
        paginationButton: "block w-3 h-3 rounded-full mx-1 bg-primary-500 opacity-50",
        buttonDisabled: "opacity-50 cursor-not-allowed",
        buttonWrapper: "w-full flex justify-end -mx-1 border-t-2 border-neutral-border pt-4",
        button: "transition ease-out duration-300 w-5 h-5 mx-1 justify-center items-center text-center text-current text-xl hidden sm:inline-flex",
        buttonLeft: "",
        buttonLeftIcon: "chevron-left",
        buttonRight: "",
        buttonRightIcon: "chevron-right"
      },
      instagram: {
        sliderOptions: {
          pagination: false,
          navigation: false,
          spaceBetween: 0,
          slidesPerView: 3,
          breakpoints: {
            768: {
              slidesPerView: 4
            },
            1024: {
              slidesPerView: 6
            }
          }
        },
        wrapper: "relative",
        slider: "sm:overflow-hidden",
        sliderItem: "flex items-center justify-center",
        slideContent: "h-full w-full",
        slideBackgroundImage: ""
      }
    }
  },
  NkForm: {
    fixedClasses: {
      wrapper: "",
      form: ""
    },
    variants: {
      default: {
        wrapper: "",
        form: ""
      },
      boxed: {
        wrapper: "",
        form: "block bg-neutral-surface p-6 rounded"
      }
    }
  },
  NkTemplateAbfalltermine: {
    fixedClasses: "",
    variants: {
      default: {
        wrapper: "",
        section: "",
        headline1: "",
        headline2: "",
        terminContainer: "-m-px  overflow-hidden",
        terminRow: "flex flex-wrap -m-3",
        termin: "w-1/2 sm:w-1/2 xl:w-1/4 p-3 border border-neutral-border"
      }
    }
  },
  NkTemplateAccessibility: {
    classes: {
      accessibilityLink: "text-white focus:text-white hover:text-white",
      container: "container bg-secondary-surface text-secondary-on-surface [&_a]:text-secondary-element [&_a:hover]:text-secondary-element [&_a:focus]:text-secondary-element [&_p]:text-secondary-on-surface"
    }
  },
  NkTemplateSpacing: {
    classes: {
      spacing: "h-px"
    },
    sizes: {
      sm: "my-2",
      default: "my-4",
      md: "my-6",
      lg: "my-8",
      xl: "my-10",
      "2xl": "my-12"
    }
  },
  NkTemplateAemterDetail: {
    classes: {
      text: "mb-3",
      zustaendigkeiten: "mb-3"
    }
  },
  NkTemplateAemterMitarbeiterUebersicht: {
    classes: {
      amt: "mb-5 pb-5 border-b border-neutral-border",
      details: "mb-2",
      details_text: "",
      details_link: ""
    }
  },
  NkTemplateAktuelles: {
    classes: {
      article: "mb-3 pb-3 border-b border-neutral-border",
      meta: ""
    }
  },
  NkTemplateAmt: {
    classes: {
      section: "",
      amt: ""
    }
  },
  NkTemplateArchivUebersicht: {
    classes: {
      archivText: "mb-3"
    }
  },
  NkTemplateArtikelOverview: {
    carouselOptions: {
      breakpoints: {},
      slidesPerView: 1
    }
  },
  NkTemplateBaugebieteKarte: {
    zoom: 18
  },
  NkTemplateBaugebieteOverview: {
    carouselOptions: {
      breakpoints: {},
      slidesPerView: 1
    }
  },
  NkTemplateBildergalerieWebcontact: {
    desc: "text-lg mb-3",
    titleSize: "xl",
    cardVariant: "imagePreview",
    cols: {
      default: "full",
      sm: "6/12",
      md: "4/12",
      lg: "4/12",
      xl: "3/12"
    }
  },
  NkTemplateBrancheneintraegeDetail: {
    classes: {
      item: "mb-5 pb-5 border-b border-neutral-border"
    }
  },
  NkTemplateBrancheneintraegeRubrik: {
    classes: {
      item: "mb-5 pb-5 border-b border-neutral-border"
    }
  },
  NkTemplateDokumente: {
    classes: {
      section: ""
    },
    accordion: {
      size: "xl"
    }
  },
  NkTemplateBildergalerien: {
    classes: {
      article: "mb-5 pb-5 border-b border-neutral-border"
    },
    carouselOptions: {
      breakpoints: {},
      slidesPerView: 1
    }
  },
  NkTemplateIFrame: {
    classes: {
      iframe: "w-full h-screen"
    }
  },
  NkTemplateMitarbeiter: {
    classes: {
      section: "",
      mitarbeiter: "border-t border-t-neutral-border mt-6 pt-6"
    }
  },
  NkTemplateMitarbeiterDetail: {},
  NkTemplateMitarbeiterUebersicht: {},
  NkTemplatepinnwandDetail: {},
  NkTemplatePinnwandUebersicht: {
    classes: {
      article: "pinnwand-artikel",
      headline: "pinnwand-artikel__headline"
    }
  },
  NkTemplateRaeteTaetigkeitsbereicheUebersicht: {},
  NkTemplateRaeteUebersicht: {},
  NkTemplateRatsinfosystemBericht: {
    classes: {
      einleitung: "text-lg"
    }
  },
  NkTemplateRatsinfosystemBerichteUebersicht: {
    classes: {
      article: "",
      article_einleitung: "mb-3"
    }
  },
  NkTemplateRatsinfosystemTermin: {
    classes: {
      section: "",
      einladung: "my-5"
    }
  },
  NkTemplateRatsinfosystemUebersicht: {
    classes: {
      article: "",
      pagination: "mt-6"
    }
  },
  NkTemplateServiceBwOrganisationseinheit: {
    classes: {
      amt: "mb-5 pb-5 border-b border-neutral-border",
      details: "mb-2",
      details_text: "",
      details_link: ""
    }
  },
  NkTemplateServiceBwOrganisationseinheiten: {
    classes: {
      amt: "mb-5 pb-5 border-b border-neutral-border",
      details: "mb-2",
      details_text: "",
      details_link: ""
    }
  },
  NkTemplateServiceBwOrganisationseinheitenMinimal: {
    classes: {
      amt: "mb-5 pb-5 border-b border-neutral-border",
      details: "mb-2",
      details_text: "",
      details_link: ""
    }
  },
  NkTemplateVeranstaltungen: {
    classes: {
      article: "mb-3 pb-3 border-b border-neutral-border"
    }
  },
  NkTemplateVeranstaltungenUebersicht: {
    carouselOptions: {
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 16,
          centeredSlides: false
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 16,
          centeredSlides: false
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 24,
          centeredSlides: false
        },
        1280: {
          slidesPerView: 2,
          spaceBetween: 24,
          centeredSlides: false
        },
        1440: {
          slidesPerView: 3,
          spaceBetween: 24,
          centeredSlides: false
        }
      }
    }
  },
  NkFilterBrancheneintraegeRubriken: {
    variants: {
      default: {
        wrapper: "",
        form: "",
        categoryList: "list-none border border-neutral-border",
        categoryItem: "border-b border-neutral-border",
        categoryItemContainer: "flex items-stretch min-h-6",
        categoryItemRow: "flex flex-1 items-center px-2 last:py-2",
        categoryLabel: "flex-1 truncate py-2 font-semibold cursor-pointer",
        subCategoryToggleButton: "block p-2 min-h-full border-l border-neutral-border",
        subCategory: "px-2 py-2 list-none border-t border-neutral-border",
        subCategoryItem: "flex items-center pl-3 hover:bg-primary-100 py-1",
        subCategoryLabel: "truncate py-2 flex-1 cursor-pointer"
      }
    }
  },
  NkFilterRatsinfosystemSitzungen: {
    classes: {
      select: "w-full p-2 border-2 border-neutral-border"
    }
  },
  NkFilterVeranstaltungenDatum: {},
  NkFilterVeranstaltungenRubriken: {
    variants: {
      default: {
        wrapper: "",
        form: "",
        categoryList: "list-none border border-neutral-border",
        categoryItem: "border-b border-neutral-border",
        categoryItemContainer: "flex items-stretch min-h-6",
        categoryItemRow: "flex flex-1 items-center px-2 last:py-2",
        categoryLabel: "flex-1 truncate py-2 font-semibold cursor-pointer",
        subCategoryToggleButton: "block p-2 min-h-full border-l border-neutral-border",
        subCategory: "px-2 py-2 list-none border-t border-neutral-border",
        subCategoryItem: "flex items-center pl-3 hover:bg-primary-100 py-1",
        subCategoryLabel: "truncate py-2 flex-1 cursor-pointer"
      }
    }
  },
  NkSidebarAktuelles: {
    classes: {
      article: "mb-3 pb-3 border-b border-neutral-border",
      meta: ""
    }
  },
  NkSidebarDokumente: {
    classes: {
      section: ""
    },
    accordion: {
      size: "xl"
    }
  }
};
export { settings, globals };
